import type { DrawingToolInstance, TwoPointCoordinates, TimestampToX, PriceToY } from "./types";
import { applyLineStyle, drawHandleCircle } from "./drawHelpers";

export function drawRectangle(
  ctx: CanvasRenderingContext2D,
  coords: TwoPointCoordinates,
  instance: DrawingToolInstance,
  timestampToX: TimestampToX,
  priceToY: PriceToY,
  draggingCoords?: TwoPointCoordinates,
) {
  const { point1, point2 } = draggingCoords ?? coords;
  const x1 = timestampToX(point1.timestamp);
  const y1 = priceToY(point1.price);
  const x2 = timestampToX(point2.timestamp);
  const y2 = priceToY(point2.price);
  const rx = Math.min(x1, x2);
  const ry = Math.min(y1, y2);
  const w = Math.abs(x2 - x1);
  const h = Math.abs(y2 - y1);

  applyLineStyle(ctx, instance.mainLine.color, instance.mainLine.width, instance.mainLine.opacity);
  ctx.strokeRect(rx, ry, w, h);

  ctx.fillStyle = instance.background.color;
  ctx.globalAlpha = instance.background.opacity / 100;
  ctx.fillRect(rx, ry, w, h);

  drawHandleCircle(ctx, x1, y1, instance.mainLine.color);
  drawHandleCircle(ctx, x2, y2, instance.mainLine.color);
}
